import { FC } from 'react';
import l from '../../../../../lang';
import CardConfirm from '../../../../common/confirm/card-confirm';
import DialogConfirm from '../../../../common/confirm/dialog-confirm';

interface DialogOtpNotSetProps {
  onClose: (confirm: boolean) => void;
}

const DialogOtpNotSet: FC<DialogOtpNotSetProps> = ({ onClose }) => {
  return (
    <DialogConfirm onClose={() => onClose(false)}>
      <CardConfirm
        onClose={onClose}
        headline={l('payouts.create.otp.notSet.title')}
        description={l('payouts.create.otp.notSet.description')}
        confirmChildren={l('payouts.create.otp.notSet.confirm')}
        cancelChildren={l('payouts.create.otp.notSet.cancel')}
        level={'warning'}
      />
    </DialogConfirm>
  );
};

export default DialogOtpNotSet;
